import * as React from 'react';

import {TooltipProps} from './TooltipTypes';

import {TooltipContainer, Tooltip} from './TooltipStyles';
import {useClickOutsideRef} from '../common';
import {useEffect, useRef} from "react";
import {Size} from "../types";

const TooltipWrapper = ({
                          label, children,
                          withArrow,
                          tabIndex,
                          size = Size.Small,
                          height = 'auto',
                          delay = undefined,
                          align = 'center',
                          position = 'bottom',
                          trigger = 'hover',
                          hideAfter = 5000,
                          ...props
                        }: TooltipProps) => {

  const [showTooltip, setShowTooltip] = React.useState(false);
  const timeoutRef = useRef<any>();

  const ref = useClickOutsideRef(() => setShowTooltip(false));

  const handleClick = (e?: MouseEvent) => {
    if (ref?.current?.contains(e?.target as Node)) {
      setShowTooltip(true)
      timeoutRef.current && clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setShowTooltip(false), hideAfter);
    }
  }
  const handleButtonDown = (e?: KeyboardEvent) => {
    if (e?.key === 'Enter' || e?.key === ' ') {
      setShowTooltip(true);
      timeoutRef.current && clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setShowTooltip(false), hideAfter);
    }
  }

  useEffect(() => {
    if (trigger == 'click') {
      document.addEventListener('mousedown', handleClick);
      ref?.current?.addEventListener('keydown', handleButtonDown);

      return () => {
        document.removeEventListener('mousedown', handleClick);
        ref?.current?.removeEventListener('keydown', handleButtonDown);
      };
    }
  }, [trigger])

  const cls = `${trigger === 'click' ? showTooltip ? 'show' : 'hide' : ''}`;
  return <TooltipContainer ref={ref}
                           delay={delay}
                           tabIndex={tabIndex}
                           triggerType={trigger}
                           className={cls}>
    <Tooltip align={align}
             height={height}
             role="tooltip"
             size={size}
             withArrow={withArrow}
             position={position}
             {...props}>
      {label}
    </Tooltip>
    {children}
  </TooltipContainer>;
};

export default TooltipWrapper;
